// ==========================================
// STEP 1: Create utils/constants.js
// ==========================================
// File: petconnect-v2/frontend/src/utils/constants.js

export const API_URL = process.env.REACT_APP_API_URL;
export const MAX_FILE_SIZE = 25 * 1024 * 1024;
export const UNREAD_MESSAGES_POLL_INTERVAL = 10 * 60 * 1000;

export const CATEGORIES = [
  { id: 'feed', name: 'Home Feed', icon: '🏠', color: 'purple' },
  { id: 'search', name: 'Search', icon: '🔍', color: 'blue' },
  { id: 'messages', name: 'Messages', icon: '💬', color: 'indigo' },
  { id: 'friends', name: 'Friends', icon: '👥', color: 'teal' },
  { id: 'adoption', name: 'Adoption', icon: '❤️', color: 'pink' },
  { id: 'missing', name: 'Missing', icon: '🔴', color: 'red' },
  { id: 'found', name: 'Found', icon: '🟢', color: 'green' },
  { id: 'success_stories', name: 'Success Stories', icon: '⭐', color: 'yellow' },
  { id: 'map_view', name: 'Map & Dual View', icon: '🗺️', color: 'cyan' },
  { id: 'about', name: 'About Us', icon: 'ℹ️', color: 'blue' }
];

export const ANIMAL_TYPES = ['cat', 'dog', 'bird', 'rabbit', 'other'];